// extracted by mini-css-extract-plugin
export default {"documents":"Documents_documents__QjqCz","header":"Documents_header__d3VDw"};